import { render } from "./UsageCompleteDetails.vue?vue&type=template&id=73cb50ab"
import script from "./UsageCompleteDetails.vue?vue&type=script&lang=js"
export * from "./UsageCompleteDetails.vue?vue&type=script&lang=js"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__